import React from "react";
import FooterBannerVedio from "../../assets/Homepage/video.mp4";
import arrow from "../../assets/Homepage/Buttonarrow.svg";
import RoundedArrowButton from "../RoundedArrowButton"


const FooterBanner = () => {
  return (
    <section className="relative w-full h-[574px] sm:h-[500px] md:h-[550px] lg:h-[574px] overflow-hidden">
      {/* Video Background */}
      <video
        className="w-full h-full object-cover"
        src={FooterBannerVedio}
        autoPlay
        loop
        muted
        playsInline
      ></video>

      {/* Overlay */}
      <div className="absolute inset-0 bg-[#2C3075] bg-opacity-70 flex flex-col justify-center items-center text-center px-4">
        
        {/* Heading */}
        <h2
          className=  " font-garamond-subheading text-white mb-3 leading-[110%]"
          
        >
          <p
            style={{
              display: "block",
              paddingLeft: "clamp(10px, 3vw, 40px)",
            }}
          >
            Take the first step towards
          </p>
          <p
            style={{
              display: "block",
              paddingRight: "clamp(10px, 3vw, 40px)",
            }}
          >
            supporting your mental health.
          </p>
        </h2>

        {/* Small Text */}
        <p
          className="font-generalsans-description text-white mb-5 text-center sm:text-right"
         
        >
          Contact us today to enquire about our services or to book an appointment
        </p>

        {/* Button */}
        <div className="my-4">
                <RoundedArrowButton label="Contact Us" to="/contact" />

        </div>
      </div>
    </section>
  );
};

export default FooterBanner;